import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CreateGridViewActionsComponent } from '@data-access/grid-views';
import { WcgFilterIndicatorsOptions } from '@shared/interfaces/wcg-table-utils.interface';
import {
  GridViews,
  WcgAdvancedFilter,
  WcgAdvancedFiltersComponent,
  WcgFilterIndicatorsComponent,
} from '@wcg/frontend-framework';

@Component({
  selector: 'wcg-ui-filter-wrapper',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    WcgAdvancedFiltersComponent,
    WcgFilterIndicatorsComponent,
    CreateGridViewActionsComponent,
  ],
  templateUrl: './ui-filter-wrapper.component.html',
  styleUrl: './ui-filter-wrapper.component.scss',
})
export class UiFilterWrapperComponent {
  advancedFilters = input<WcgAdvancedFilter>();
  appliedFilters = input<WcgAdvancedFilter>();
  gridViewData = input<GridViews>();
  advancedFiltersFormGroup = input<FormGroup>();

  applyFilters = output<WcgAdvancedFilter[]>();
  clearFilters = output<void>();
  revertGridState = output<void>();
  removeFilter = output<WcgFilterIndicatorsOptions>();
}
